import {
  API_URL
} from 'api/constants'

export const EMPLOYEES = `${API_URL}/v1/employees`
export const ASSIGNED_STAFF = `${API_URL}/v1/employees/get_assigned_staff`
/**
 * @return {string}
 */
export function EMPLOYEE (id) { return `${API_URL}/v1/employees/${id}` }

export const RESEND_INVITATION = `${API_URL}/v1/employees/resend_invitation`



// WEBPACK FOOTER //
// ./app/api/employees/constants.js